export default __webpack_public_path__ + "static/media/netvrk-v2-5.95b8f6aa.jpg";